import { render, staticRenderFns } from "./GoBack.vue?vue&type=template&id=5ffe64f9&scoped=true&"
import script from "./GoBack.vue?vue&type=script&lang=ts&"
export * from "./GoBack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffe64f9",
  null
  
)

export default component.exports